module.exports = __webpack_public_path__ + "img/img10.66e0d7e6.svg";